<template>
  <h2 class="heading-caps mb-1" v-html="store.selectedCard.enjoy_benefits_heading"></h2>
  <h3 class="subheading" v-html="store.selectedCard.enjoy_benefits_subheading"></h3>
  <a :href="store.selectedCard.enjoy_benefits_href" class="btn-2 mt-2" target="_blank">See All Benefits</a>
</template>

<script setup>
import { useStore } from '../store';
const store = useStore();
</script>
